import api_fetch from '../utils/api_fetch';
import { storageHandler } from '../utils/storage_handler';

const zoeShipmentTrackingService = {
  async getList(page = 1, limit = 20) {
    const offset = (page - 1) * limit;
    const params = new URLSearchParams({ offset, limit });

    return (
      await api_fetch.get(
        `/v1/shipment-tracking?${params.toString()}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      )
    ).json();
  },

  async searchByListField(
    filters = {},
    page = 1,
    sortBy,
    sortOrder,
    limit = 20
  ) {
    const offset = (page - 1) * limit;
    const params = new URLSearchParams();

    params.append('limit', limit.toString());
    params.append('offset', offset.toString());

    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    if (
      sortBy &&
      sortOrder &&
      sortBy !== 'default' &&
      sortOrder !== 'default'
    ) {
      params.append('sort_by', sortBy);
      params.append('sort_order', sortOrder);
    }

    const response = await api_fetch.get(
      `/v1/search-shipment?${params.toString()}`,
      {
        Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
      },
      {}
    );

    return response.json();
  },

  async getShipmentTracking(id) {
    return (
      await api_fetch.get(
        `/v1/shipment-tracking/${id}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      )
    ).json();
  },

  async updateShipmentTracking(id, data) {
    return (
      await api_fetch.put(
        `/v1/shipment-tracking/${id}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        data
      )
    ).json();
  }
};

export default zoeShipmentTrackingService;
